import React from "react";
import config from "../../../config";

function ImageElement({
  previewSource = "",
  source,
  imageFor = "user",
  alt,
  origin = "anonymous",
  ...rest
}) {
  const imagePath = {
    user: config.IMAGE_URL,
    admin: config.ADMIN_IMAGE_URL
  };
  return (
    <>
      {previewSource ? (
        <img crossOrigin={origin} src={`${config.BASENAME}${previewSource}`} alt={alt} {...rest} />
      ) : (
        <>
          {source ? (
            <img
              src={`${config.BASENAME}${imagePath[imageFor]}/${source}`}
              crossOrigin={origin}
              alt={`${source.split('/').pop().split('.').slice(0, -1)}-img`}
              {...rest}
            />
          ) : (
            <img
              src={`${config.BASENAME}${imagePath[imageFor]}/profile-img.jpg`}
              alt="userImage"
            />
          )}
        </>
      )}
    </>
  );
}

export default ImageElement;
